import { useEffect } from 'react';

// Bloqueo del scroll de la página para modales, visores y paneles.
//
// Es la única forma de tocar document.body.style.overflow en la web. Antes cada
// componente lo escribía a mano ('hidden' al abrir; 'unset', '' o "lo que había"
// al cerrar) y se pisaban entre sí: uno desbloqueaba la página con otro modal
// todavía abierto, y el aviso de edad restauraba un 'hidden' viejo cuando ya se
// había cerrado el perfil, dejando la pantalla congelada.
//
// Aquí hay un contador compartido: el primero que bloquea guarda el valor
// original y pone 'hidden'; la página solo se libera cuando se suelta el último
// bloqueo, sin importar el orden en que se abran o cierren.
let activeLocks = 0;
let savedOverflow = '';

/**
 * Bloquea el scroll y devuelve la función que suelta ese bloqueo (idempotente).
 * Úsala directamente solo cuando el bloqueo depende de algo que un hook no
 * puede expresar (p. ej. el ancho de la ventana); si no, usa useBodyScrollLock.
 */
export function lockBodyScroll() {
  if (typeof document === 'undefined') return () => {};

  if (activeLocks === 0) {
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  activeLocks += 1;

  let released = false;
  return () => {
    if (released) return;
    released = true;
    activeLocks = Math.max(0, activeLocks - 1);
    if (activeLocks === 0) {
      // Si algo dejó 'hidden' antes de nosotros, no se lo devolvemos a la página.
      document.body.style.overflow = savedOverflow === 'hidden' ? '' : savedOverflow;
    }
  };
}

/** Mientras `active` sea true, la página no hace scroll. Se suelta sola al desmontar. */
export default function useBodyScrollLock(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    return lockBodyScroll();
  }, [active]);
}
